import { forwardRef } from 'react';
import { Badge, Group, Text } from '@/components/ui';
import type { PresenceIndicatorProps } from '../types';
import { usePreferencesStore } from '../../../../stores';
import { LINE_HEIGHT_MAP, LETTER_SPACING_MAP } from '../../../../hooks/useAccessibilityStyles';

export const PresenceIndicator = forwardRef<HTMLDivElement, PresenceIndicatorProps>(
  (props, ref) => {
    const { status = 'Offline', showStatus = true, size = 'md' } = props;

    const lineSpacing = usePreferencesStore((state) => state.lineSpacing);
    const letterSpacingPref = usePreferencesStore((state) => state.letterSpacing);

    const accessibilityStyles = {
      lineHeight: LINE_HEIGHT_MAP[lineSpacing],
      letterSpacing: LETTER_SPACING_MAP[letterSpacingPref],
    };

    const colorMap = {
      Online: 'green',
      Away: 'yellow',
      Busy: 'red',
      Offline: 'gray',
    };

    return (
      <Group gap="xs" ref={ref}>
        <div
          style={{
            width: size === 'sm' ? 8 : size === 'md' ? 10 : 12,
            height: size === 'sm' ? 8 : size === 'md' ? 10 : 12,
            borderRadius: '50%',
            backgroundColor: `var(--mantine-color-${colorMap[status]}-5)`,
          }}
        />
        {showStatus && <Text size={size === 'sm' ? 'xs' : 'sm'} style={accessibilityStyles}>{status}</Text>}
      </Group>
    );
  }
);

PresenceIndicator.displayName = 'PresenceIndicator';
export default PresenceIndicator;
